import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiButton, EuiSpacer } from '@elastic/eui';
import FWChangelog from 'components/Search/FW1440pclSearch';
import NavButtons from "components/Downloads/Outdoor_Cameras/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-8403 WQHD Downloads",
  "path": "/Downloadbereich/Innenkameras/IN-8403_WQHD/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR Firmware, WebUI und Dokumentations-Downloads",
  "image": "./P_SearchThumb_IN-8403WQHD_Downloads.png",
  "social": "/images/Search/P_SearchThumb_IN-8403WQHD_Downloads.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Downloads_white.webp",
  "chapter": "Downloads"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title="Download Area - IN-8403 WQHD" dateChanged="2018-09-20" author="Mike Polinowski" tag="INSTAR IP Camera" description="INSTAR Firmware, WebUI und Dokumentations-Downloads" image="/images/Search/P_SearchThumb_IN-8403WQHD_Downloads.png" twitter="/images/Search/P_SearchThumb_IN-8403WQHD_Downloads.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Downloads/Indoor_Cameras/IN-8403_WQHD/" locationFR="/fr/Downloads/Indoor_Cameras/IN-8403_WQHD/" crumbLabel="IN-8403" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "downloadbereich",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#downloadbereich",
        "aria-label": "downloadbereich permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Downloadbereich`}</h1>
    <h2 {...{
      "id": "innenkameras",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#innenkameras",
        "aria-label": "innenkameras permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Innenkameras`}</h2>
    <h2 {...{
      "id": "in-8403-2k-wqhd-downloads",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-8403-2k-wqhd-downloads",
        "aria-label": "in 8403 2k wqhd downloads permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-8403 2k+ WQHD Downloads`}</h2>
    {
      /* TOC */
    }
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#innenkameras"
        }}>{`Innenkameras`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#in-8401-2k-wqhd-downloads"
        }}>{`IN-8401 2k+ WQHD Downloads`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#software-installation-wizard"
        }}>{`Software Installation Wizard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#anleitungen"
        }}>{`Anleitungen`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#schnellinstallation"
            }}>{`Schnellinstallation`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#updates-kamera-software"
        }}>{`Updates Kamera-Software`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#firmware"
            }}>{`Firmware`}</a>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#download"
                }}>{`Download`}</a></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    {
      /* /TOC */
    }
    <h2 {...{
      "id": "software-installation-wizard",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#software-installation-wizard",
        "aria-label": "software installation wizard permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Software Installation Wizard`}</h2>
    <p>{`Jedes INSTAR Produkt wird mit einer Installations-CD ausgeliefert. Die CD beinhaltet einen Installationsassistenten der Sie durch die Einrichtung Ihres neuen INSTAR Produktes leitet. Der Installationsassistent kann auch direkt aufgerufen werden indem Sie unten auf den Link klicken und somit die CD online öffnen. Der Assistent enthält alle Informationen und aktuelle Download-Links die Sie für die Installation benötigen.`}</p>
    <p>{`Die Software CD beinhaltet einen HTML Einrichtungsassistenten der Sie durch die benötigten Einstellungen leitet und Ihnen die aktuellen Downloadlinks für Ihr INSTAR Produkt anzeigt.`}</p>
    <p><strong parentName="p">{`Schnellinstallations-Assistent`}</strong>{`: Der Assistent leitet Sie durch die wichtigsten Schritte um Ihr INSTAR Produkt in Betrieb zu nehmen.`}</p>
    <p><strong parentName="p">{`Software Installation`}</strong>{`: Sie finden Download Links sofern Ihr INSTAR Produkt zusätzliche Software benötigt. Sie werden durch alle Schritte geleitet nachdem Sie den Download und die Installation abgeschlossen haben.`}</p>
    <p><strong parentName="p">{`Firmware Updates`}</strong>{`: INSTAR bietet in regelmäßigen Abständen Firmware und WebUI Updates für seine Produkte an. Weiter unten finden Sie die aktuellen Versionen der Firmware und WebUI die Sie auf Ihre INSTAR Kamera aufspielen können.`}</p>
    <a href="https://install.instar.com/" target="_blank" rel="noopener noreferrer"><button className="btn">Installation Starten</button></a>
    <h2 {...{
      "id": "anleitungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#anleitungen",
        "aria-label": "anleitungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Anleitungen`}</h2>
    <h3 {...{
      "id": "schnellinstallation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#schnellinstallation",
        "aria-label": "schnellinstallation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Schnellinstallation`}</h3>
    <p>{`Die Bedienungsanleitung beinhaltet ausführliche Informationen zu allen Funktionen der Kamera.`}</p>
    <OutboundLink to="https://wiki.instar.com/dl/IN-8403WQHD/QuickInstallation-1440p-IN-8403WQHD.pdf" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
  <EuiButton fill mdxType="EuiButton">Start Installation</EuiButton>
    </OutboundLink>
    <h2 {...{
      "id": "updates-kamera-software",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#updates-kamera-software",
        "aria-label": "updates kamera software permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Updates Kamera-Software`}</h2>
    <h3 {...{
      "id": "firmware",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#firmware",
        "aria-label": "firmware permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Firmware`}</h3>
    <p>{`Sie finden hier immer die neueste Version und alle Vorgängerversionen der Firmware für Ihre Kamera. Sofern Sie ein Update der WebUI planen, stellen Sie immer sicher, dass Sie die neueste Version der Firmware installiert haben. In den meisten Fällen erfordern die neuen Funktionen in der Weboberfläche (WebUI) auch die neueste Firmware. Für Informationen wie Sie die Firmware updaten schauen Sie bitte `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/WebUI_und_Firmware_Upgrade/"
      }}>{`hier`}</a>{`.`}</p>
    <p><strong parentName="p">{`Wichtig`}</strong>{`: Entpacken Sie nach dem Download bitte die *.ZIP Datei. Beachten Sie auch das Sie zuerst die neueste Firmware installieren und erst dann die WebUI.`}</p>
    <h4 {...{
      "id": "download",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#download",
        "aria-label": "download permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Download`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://update.instar.de/download/2k+Series/instar-update-2k.zip"
        }}>{`Download Latest Version`}</a></li>
    </ul>
    <EuiSpacer mdxType="EuiSpacer" />
    <FWChangelog mdxType="FWChangelog" />
    {
      /*
      * Was ist neu in Version 1.4.3-1.4.3 [548] ?
        * Verbesserte Kompatibilität mit HomeKit Secure Video beim Einsatz mehreren Apple Homekit Hubs
        * Algemeine Bugfixes und Verbesserungen in der HomeKit Anbindung
        * Erweiterte MQTT API (geplante Aufnahme, Aufnahmestatus, Pushbenachrichtigung)
      <br/>
      
      * Was ist neu in Version 1.4.2-1.4.2 [539] ?
        * HomeKit Secure Video - Holen Sie nun das Beste aus Ihren Apple-Geräten mit HomeKit-Unterstützung raus
        * HomeKit-Standard-konformes LED-Handling sofern HomeKit aktiv ist
        * Bei MQTT ist das Mindest-Sicherheitsprotokoll nun einstellbar
        * MQTT unterstützt nun verschlüsselte WebSocket-Verbindungen
        * Das SSL-Zertifikat wurde aktualisiert
        * Die Rollen der zusätzlichen Benutzer aus dem Auslieferungszustand sind nun anpassbar
        * Die Kompatibilität des RTSP-Stream für Drittanbieter-Geräte wurde verbessert
        * E-Mail Betreff für die Fotoserie ist nun im E-Mail-Menü unter Features anpassbar
        * Verbesserte Touch-Unterstützung für mobile Geräte bei den Objekterkennungsgrenzwerten
        * Der Systemstart verläuft nun zügiger
        * Generelle Sicherheitsupdates
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.4.1-1.4.1 [515] ?
        * Die zusätzlichen IR-Dioden können bei Alarm in unterstützten Modellen dazugeschaltet werden
        * Vorbereitung auf neue Kameramodelle
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.4.0-1.4.0 [512] ?
        * Überarbeitung des Privatsphäre-Menüs - Es ist nun möglich, nicht-rechteckige und bis zu 8 Bereiche festzulegen. Beachten Sie, dass sich die CGI API in diesem Bereich geändert hat!
        * Verbesserte Touch-Unterstützung für mobile Geräte in den Menüs mit Bereichen
        * Überarbeitung der Benutzerverwaltung - Bis zu 10 Benutzer können jetzt angelegt werden
        * Jeder Benutzer kann nun seinen persönlichen Login bearbeiten
        * Ab sofort werden die aktiven Sessions eines Benutzers gelöscht, sobald sich dessen Benutzerdaten ändern
        * Kompatibilität für Modelle 8403 2K+ und 8415 2K+
        * Rauschfilter für das Mikrofon ist nun im Audio-Menü verfügbar
        * Echo-Unterdrückung für den Audio-Kanal ist nun verfügbar
        * Die Video-Kodierung ist nun für alle drei Video-Kanäle frei einstellbar
        * Die kleinste Auflösung (Kanal 13) wurde auf 720p (HD) erhöht und die Kodierung standardmäßig auf H264 gesetzt
        * P2P-Library wurde geupdated - Ein Update der Instarvision APP ist erforderlich, um eine reibungslose P2P-Anbindung weiterhin zu gewährleisten
        * Alarmdaten werden nun parallel zum Live-Video über die WebSocket-Verbindung mitgesendet
        * Die iPad-Kompatibilität zu HomeKit wurde verbessert
        * Probleme, die die Zuverlässigkeit von HomeKit beeinträchtigt haben, wurden behoben
        * Ein Problem, das in manchen Fällen den FTP-Upload behindert hat, wurde behoben
        * Quality-of-Service (QoS) Option wurde bei MQTT hinzugefügt
        * Die maximale Länge einer Videodatei beträgt bei manuellen und geplanten Aufnahmen nun 15 Minuten
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.3.3-1.3.1 [476] ?
        * DDNS-Unterstützung für Modell IN-8401 2K+
      <br/>
      
      * Was ist neu in Version 1.3.2-1.3.1 [464] ?
        * Bis zu vier Server können nun bei Secure NTP hinterlegt werden
        * Verbesserungen in den HomeKit-Implementationen
        * MQTT-Translations wurden aktualisiert
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.3.1-1.3.0 [449] ?
        * Probleme in HomeKit nach dem letzten Update bzgl. der Alarmbenachrichtigung und dem gleichzeitigen Zugriff von mehreren iOS-Geräten wurden behoben
      <br/>
      
      * Was ist neu in Version 1.3.0-1.3.0 [445] ?
        * H265-Video-Stream-Unterstützung (1440p & 360p) für Google Chrome
        * Das "Mein Konto"-Menü erlaubt jedem Benutzer, seine Kontoeinstellungen anzupassen
        * Die Spracheinstellung ist jetzt Teil der Kontoeinstellung
        * Zwei-Faktor-Authentifizierung (2FA) für mehr Sicherheit beim Login
        * Das Benutzerpasswort kann nun beim Login zurückgesetzt werden
        * 2FA und die Zurücksetzung des Passwortes setzen voraus, dass der Benutzer seine E-Mail-Adresse im neuen "Mein Konto"-Menü hinterlegt hat
        * Secure NTP (auch bekannt unter NTS/NTPsec) ist nun als Alternative zu NTP verfügbar
        * Es können jetzt zwei weitere Alarm-Server mit eigener Konfiguration kontaktiert werden
        * Eine Testfunktion wurde zum Alarm-Server hinzugefügt, um die Anfrage mit den gewünschten Auslösern zu simulieren und um die Verbindung zum Server zu testen
        * Die Sortierung der WLAN-Ergebnisse erfolgt nun wie erwartet nach der Signalqualität
        * Die Zuverlässigkeit der HomeKit-Verbindung wurde verbessert
        * Allgemeine Bugfixes und Verbesserungen
        * Wir empfehlen, den Zwischenspeicher Ihres Webbrowsers nach diesem Update zu leeren!
      <br/>
      
      * Was ist neu in Version 1.2.0-1.2.0 [414] ?
        * Schutz gegen Brute-Force-Attacken
        * Strengere HTTP-Security-Header
        * Neues Objekterkennungsmenü! Legen Sie Mindest- & Maximalgröße und den Grenzwert für die Übereinstimmung für die einzelnen Objekttypen fest!
        * Digitaler Zoom kann nun auf das Live-Video angewendet werden
        * Neuerungen und Bugfix im Alarmserver-Menü. Alarmauslöser können individuell deaktiviert werden, um die Alarm-Push-Anfrage von Bestimmten Auslösern zu unterbinden.
        * Die Zeitpläne für die Fotoserie und für die Daueraufnahme wurden vom Master-Zeitplan, welcher als übergeordneter Zeitplan für die Alarmzeitpläne fungiert, entkoppelt.
        * Verbindungen zu ungeschützten WLAN-Netzwerken sind nun erlaubt
        * Dateien und Ordner im Root-Verzeichnis der SD-Karte die nicht von der Kamera erstellt wurden, werden von der automatischen Löschung der SD-Daten ausgeschlossen.
        * E-Mail-Fotoserie wurde hinzugefügt
        * RTSP kann nun deaktiviert werden. RTSP-Einstellungen befinden sich jetzt im RTSP-Menü
        * Testfunktion für Alarmserver und MQTT (CGI)
        * HomeKit-Log Funktion wurde hinzugefügt (CGI)
        * MQTT Updates
        * Es wurden neue Sprachen zur WebUI hinzugefügt
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.1.1-1.1.0 [380] ?
        * Strengere Passwortanforderung
        * Die UI schätzt den Sicherheitsgrad des Passworts ein und gibt Verbesserungsvorschläge
        * Die Schritte im Wizard wurden neu angeordnet und ein Update-Schritt wurde hinzugefügt
        * Experimentell: Umsetzung für Mindest- & Maximalgröße für Objekterk. überarbeitet (CGI)
        * Ein Problem mit dem E-Mail-Versand wurde behoben
        * Ein Problem bei der geplanten Daueraufnahme wurde behoben
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.1.0-1.0.5 [367] ?
        * Alarmbereiche lassen sich nun individuell mit dem PIR koppeln
        * Ein Problem beim PIR-gesteuerten Nachtmodus wurde behoben
        * Für Entwickler: Alarm- & Objektinformationen sind im Datenstream des Videos enthalten
        * Experimentell: Bei der Objekterkennung lässt sich via CGI Mindest- & Maximalgröße definieren
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.0.2-1.0.4 [358] ?
        * Ein Problem in der Benutzerverwaltung in der WebUI wurde behoben
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.0.2-1.0.3 [356] ?
        * Changelog ist im Update-Menü abrufbar
        * Ein Problem bei der logischen Verknüpfung in der Objekterkennung wurde behoben
        * Für die Objekterkennung ist nun der Schwellwert, ab dem das Objekt als solches identifiziert wird, in der Alarmkonfiguration regelbar
        * Die Hintergrundfarbe für die Privatspährebereiche ist jetzt konfigurierbar
        * Der Kameraname wird nun im Browser-Titel angezeigt
        * Zuverlässigkeit des E-Mail-Versandes wurde erhöht
        * Stabilität der P2P-Verbindung wurde verbessert
        * Allgemeine Bugfixes und Verbesserungen
      <br/>
      
      * Was ist neu in Version 1.0.1-1.0.2 [349] ?
        * Ein Problem wurde behoben, wobei die Speicherung der Alarm-Server-Konfiguration mit weniger als 5 Query-Parameter verhindert wurde
      <br/>
      
      * Was ist neu in Version 1.0.1-1.0.1 [348] ?
        * WebUI lädt nun korrekt in den Operator- und Guest-Account
        * Ein Problem in der Benutzerverwaltung wurde behoben, der es manchmal nicht möglich machte alle 3 Benutzer gleichzeitig zu bearbeiten.
        * Ein Problem bei den E-Mails wurde behoben
        * HomeKit-Zuverlässigkeit wurde erhöht
        * Allgemeine Bugfixes und Verbesserungen
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      